var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete, CircularProgress, Avatar } from '@mui/material';
/**
 * Main component to select a madbox application
 */
export var MadAppSelector = function (_a) {
    var value = _a.value, onChange = _a.onChange, apps = _a.apps, loading = _a.loading, style = _a.style, typesToDisplay = _a.typesToDisplay, label = _a.label, sx = _a.sx, disableClearable = _a.disableClearable;
    var currentSlug = (value === null || value === void 0 ? void 0 : value.slug) || '';
    var _b = useState([]), localApps = _b[0], setLocalApps = _b[1];
    // Display only the apps with the types we want to display
    useEffect(function () {
        if (!apps)
            return;
        // By default we display only the "Game" type
        var currentTypesToDisplay = typesToDisplay ? typesToDisplay : ['game'];
        // Allow parameter to be just a single string
        if (typeof currentTypesToDisplay === 'string')
            currentTypesToDisplay = [currentTypesToDisplay];
        // Display all the apps if you indicate 'all'
        if (currentTypesToDisplay[0] === 'all') {
            setLocalApps(apps);
            return;
        }
        // Filter the apps to get the app with the good types to display
        setLocalApps(apps.filter(function (app) { return app.type && currentTypesToDisplay.indexOf(app.type.id) > -1; }));
    }, [apps, typesToDisplay]);
    return (_jsx(Autocomplete, { style: style, sx: sx, size: "small", getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.text) || ''; }, isOptionEqualToValue: function (option, _a) {
            var value = _a.value;
            return option.value === value || option.value === currentSlug;
        }, value: value ? { value: value.slug, text: value.name, image: value.icon_url, app: value } : null, onChange: function (e, currentValue) {
            if (currentValue === null) {
                onChange(null);
            }
            else {
                onChange(currentValue.app);
            }
        }, options: localApps ? localApps.map(function (app) { return ({ value: app.slug, text: app.name, image: app.icon_url, app: app }); }) : [], disableClearable: disableClearable, renderInput: function (params) {
            return (_jsx(TextField, __assign({}, params, { placeholder: label || 'Application', InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(React.Fragment, { children: [loading ? _jsx(CircularProgress, { color: "inherit", size: 20 }, void 0) : null, params.InputProps.endAdornment] }, void 0)) }) }), void 0));
        }, renderOption: function (props, option) {
            return (_createElement("li", __assign({}, props, { key: props.id }),
                _jsx(Avatar, __assign({ sizes: "small", alt: option.text, variant: "rounded", src: option.image, style: { marginRight: 20 } }, { children: option.text[0] }), void 0),
                option.text));
        } }, void 0));
};
